// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { Search as FoundationSearch, searchTemplate as template } from '@microsoft/fast-foundation';
import { searchStyles as styles } from './search.styles.js';
/**
 * @internal
 */
export class Search extends FoundationSearch {
    constructor() {
        super(...arguments);
        /**
         * The appearance of the element.
         *
         * @public
         * @remarks
         * HTML Attribute: appearance
         */
        this.appearance = 'outline';
    }
}
__decorate([
    attr
], Search.prototype, "appearance", void 0);
/**
 * A function that returns a {@link @microsoft/fast-foundation#Search} registration for configuring the component with a DesignSystem.
 * Implements {@link @microsoft/fast-foundation#searchTemplate}
 *
 *
 * @public
 * @remarks
 * Generates HTML Element: `<jp-search>`
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/delegatesFocus | delegatesFocus}
 */
export const jpSearch = Search.compose({
    baseName: 'search',
    baseClass: FoundationSearch,
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true
    }
});
/**
 * Styles for Search
 * @public
 */
export const searchStyles = styles;
